import AmericanExpress from "../assets/Cards/American Express.svg";
import CreditCard from "../assets/Cards/Credit Card.svg";
import DebitCard from "../assets/Cards/Debit Card.svg";
import Discover from "../assets/Cards/Discover.svg";
import MasterCard from "../assets/Cards/MasterCard.svg";
import Paypal from "../assets/Cards/Paypal.svg";
import RuPay from "../assets/Cards/RuPay.svg";
import Visa from "../assets/Cards/Visa.svg";
import moment from "moment";
import "moment-timezone";
import { useSelector } from "react-redux";
import activestatus from "../../src/assets/images/activeStatus.svg";
import inactivestatus from "../../src/assets/images/inactivestatus.svg";
import doublearrow from "../../src/assets/images/log-double-arrow.svg";
import CryptoJS from "crypto-js";
import workflowIcon from "../assets/images/Workflow.svg";
import developerorg from "../assets/images/WFMain.svg";
import community from "../assets/images/Community.svg";
import StatusImgIcon from "../component/common-component/StatusImgIcon";
import axios from "axios";
const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const cryptoKey = "SqT_mR_Pr@k@$h_27091992";

export const commonservices = {
    fnCheckValidationOfObject,
    getItem,
    createGuid,
    NewUTCFormat,
    BasicUTCTime,
    setItem,
    getAgo,
    HidePassword,
    getTimeInFormat,
    getDecryptData,
    getHeadersFromData,
    getHeaders,
    getDateInFormatCustom,
    getStatusUI,
    calculateDuration,
    calculateDurationSec,
    getAllTimeZoneList,
    FileSizeMBGB,
    convertTimeToLocal,
    convertDateToLocal,
    NumberCalculateValue,
    truncateText,
    stripHTML,
    IsValidJson,
    fnCommonValueFill,
    MachineStatus,
    GetRoleAccess,
    GetRoleAccessDetails,
    GetCurrentDate,
    getDateInDBFormat,
    getWalkthroughDetail,
    clearLocalStorage,
    isDomainCheck,
    getStatus,
    getWithoutDotStatus,
    formateAmount,
    getDateInFormat,
    getUserLogDataInFormat,
    getlogPopupStatus,
    getlogPopupStatusCapsule,
    getWorkflowStatusColor,
    UserLogPanalAction,
    setupKeyPressHandler,
    downloadFileFromURL,
    readJsonFileFromUrl,
    convertDateAndTimeInLocalTimeZone,
    makeMachineDisplayName,
    validateJsonString,
    CreateColor,
    fnTotalMonths,
    fnAmountDigitCount,
    fnLastYearList,
    CalculateUseInPersentage,
    getNewTimeZone,
    FillMultiSelectValue,
    bodyEncryption,
    bodyDecryption,
    fnORGIcon,
    getKeyPaths,
    GenerateGUID,
    GetTotalMinutesBaseOnDateTime,
    getFileExtension,
    getWorkflowTimeLineStatus,
    ConvetSecondInTimeFormate,
    GetSecondCounts,
    convertTimeToLocal12Formate,
    getDateTimeInDBFormat,
    convertTimeToLocal12ForAsID,
    extractArrayKeyPaths,
    getJsonPathsWithType,
    getQDDataTypeBaseOnType,
    getJsonPathsWithType_WithouArrayKayWherePosition,
    TopOlogicalSort
};
let key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_KEY);
let iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_IV);
export const AppConfigData = {
    CryptoKey: cryptoKey,
};
export const CountCharacter = {
    MachineName: 15,
    MachineShortDetail: 40,
    MarketPlaceShortDetail: 70,
    MarketPlaceReviewDetail: 245,
    ProjectCard: 28,
    ReviewTitle: 14,
    HeaderDisplayName: 14,
    RejectedComment: 230,
};
export const MACHINE_TYPE_PARAMETER = ["string", "integer", "array", "decemal"];
export const ORGANIZATION_TITLE = ["Workflow", "Developer", "Community"];
export const MACHINE_DATATYPE_PARAMETER = ["string", "integer", "decemal"];
export const MINUTES_ARRAY = [0, 15, 30, 45];
export const DAY_MAPPING = {
    Sunday: "0",
    Monday: "1",
    Tuesday: "2",
    Wednesday: "3",
    Thursday: "4",
    Friday: "5",
    Saturday: "6",
};
export const MONTH_MAPPING = {
    January: "0",
    February: "1",
    March: "2",
    April: "3",
    May: "4",
    June: "5",
    July: "6",
    August: "7",
    September: "8",
    October: "9",
    November: "10",
    December: "11",
};
export const monthMap = {
    January: "Jan",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec",
};
export const YES_NO_ARRAY = ["Yes", "No"];
export const MONTHS_ARRAY = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
export const CurrentYear = new Date().getFullYear();
export const MonthsArrayList = [
    { short: "Jan", full: "January", number: 1 },
    { short: "Feb", full: "February", number: 2 },
    { short: "Mar", full: "March", number: 3 },
    { short: "Apr", full: "April", number: 4 },
    { short: "May", full: "May", number: 5 },
    { short: "Jun", full: "June", number: 6 },
    { short: "Jul", full: "July", number: 7 },
    { short: "Aug", full: "August", number: 8 },
    { short: "Sep", full: "September", number: 9 },
    { short: "Oct", full: "October", number: 10 },
    { short: "Nov", full: "November", number: 11 },
    { short: "Dec", full: "December", number: 12 },
];
export const SKELETON_NAME = {
    singleProjectCard: "singleProjectCard",
};
export const TIMEZONE_LIST = [
    {
        displayName: "(GMT +00:00) Africa/Abidjan",
        value: "Africa/Abidjan",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Africa/Accra",
        value: "Africa/Accra",
        shortValue: "GMT",
    },
    {
        displayName: "(EAT +03:00) Africa/Addis_Ababa",
        value: "Africa/Addis_Ababa",
        shortValue: "EAT",
    },
    {
        displayName: "(CET +01:00) Africa/Algiers",
        value: "Africa/Algiers",
        shortValue: "CET",
    },
    {
        displayName: "(EAT +03:00) Africa/Asmara",
        value: "Africa/Asmara",
        shortValue: "EAT",
    },
    {
        displayName: "(EAT +03:00) Africa/Asmera",
        value: "Africa/Asmera",
        shortValue: "EAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Bamako",
        value: "Africa/Bamako",
        shortValue: "GMT",
    },
    {
        displayName: "(WAT +01:00) Africa/Bangui",
        value: "Africa/Bangui",
        shortValue: "WAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Banjul",
        value: "Africa/Banjul",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Africa/Bissau",
        value: "Africa/Bissau",
        shortValue: "GMT",
    },
    {
        displayName: "(CAT +02:00) Africa/Blantyre",
        value: "Africa/Blantyre",
        shortValue: "CAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Brazzaville",
        value: "Africa/Brazzaville",
        shortValue: "WAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Bujumbura",
        value: "Africa/Bujumbura",
        shortValue: "CAT",
    },
    {
        displayName: "(EET +02:00) Africa/Cairo",
        value: "Africa/Cairo",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Africa/Ceuta",
        value: "Africa/Ceuta",
        shortValue: "CET",
    },
    {
        displayName: "(GMT +00:00) Africa/Conakry",
        value: "Africa/Conakry",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Africa/Dakar",
        value: "Africa/Dakar",
        shortValue: "GMT",
    },
    {
        displayName: "(EAT +03:00) Africa/Dar_es_Salaam",
        value: "Africa/Dar_es_Salaam",
        shortValue: "EAT",
    },
    {
        displayName: "(EAT +03:00) Africa/Djibouti",
        value: "Africa/Djibouti",
        shortValue: "EAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Douala",
        value: "Africa/Douala",
        shortValue: "WAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Freetown",
        value: "Africa/Freetown",
        shortValue: "GMT",
    },
    {
        displayName: "(CAT +02:00) Africa/Gaborone",
        value: "Africa/Gaborone",
        shortValue: "CAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Harare",
        value: "Africa/Harare",
        shortValue: "CAT",
    },
    {
        displayName: "(SAST +02:00) Africa/Johannesburg",
        value: "Africa/Johannesburg",
        shortValue: "SAST",
    },
    {
        displayName: "(CAT +02:00) Africa/Juba",
        value: "Africa/Juba",
        shortValue: "CAT",
    },
    {
        displayName: "(EAT +03:00) Africa/Kampala",
        value: "Africa/Kampala",
        shortValue: "EAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Khartoum",
        value: "Africa/Khartoum",
        shortValue: "CAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Kigali",
        value: "Africa/Kigali",
        shortValue: "CAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Kinshasa",
        value: "Africa/Kinshasa",
        shortValue: "WAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Lagos",
        value: "Africa/Lagos",
        shortValue: "WAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Libreville",
        value: "Africa/Libreville",
        shortValue: "WAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Lome",
        value: "Africa/Lome",
        shortValue: "GMT",
    },
    {
        displayName: "(WAT +01:00) Africa/Luanda",
        value: "Africa/Luanda",
        shortValue: "WAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Lubumbashi",
        value: "Africa/Lubumbashi",
        shortValue: "CAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Lusaka",
        value: "Africa/Lusaka",
        shortValue: "CAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Malabo",
        value: "Africa/Malabo",
        shortValue: "WAT",
    },
    {
        displayName: "(CAT +02:00) Africa/Maputo",
        value: "Africa/Maputo",
        shortValue: "CAT",
    },
    {
        displayName: "(SAST +02:00) Africa/Maseru",
        value: "Africa/Maseru",
        shortValue: "SAST",
    },
    {
        displayName: "(SAST +02:00) Africa/Mbabane",
        value: "Africa/Mbabane",
        shortValue: "SAST",
    },
    {
        displayName: "(EAT +03:00) Africa/Mogadishu",
        value: "Africa/Mogadishu",
        shortValue: "EAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Monrovia",
        value: "Africa/Monrovia",
        shortValue: "GMT",
    },
    {
        displayName: "(EAT +03:00) Africa/Nairobi",
        value: "Africa/Nairobi",
        shortValue: "EAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Ndjamena",
        value: "Africa/Ndjamena",
        shortValue: "WAT",
    },
    {
        displayName: "(WAT +01:00) Africa/Niamey",
        value: "Africa/Niamey",
        shortValue: "WAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Nouakchott",
        value: "Africa/Nouakchott",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Africa/Ouagadougou",
        value: "Africa/Ouagadougou",
        shortValue: "GMT",
    },
    {
        displayName: "(WAT +01:00) Africa/Porto-Novo",
        value: "Africa/Porto-Novo",
        shortValue: "WAT",
    },
    {
        displayName: "(GMT +00:00) Africa/Sao_Tome",
        value: "Africa/Sao_Tome",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Africa/Timbuktu",
        value: "Africa/Timbuktu",
        shortValue: "GMT",
    },
    {
        displayName: "(EET +02:00) Africa/Tripoli",
        value: "Africa/Tripoli",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Africa/Tunis",
        value: "Africa/Tunis",
        shortValue: "CET",
    },
    {
        displayName: "(CAT +02:00) Africa/Windhoek",
        value: "Africa/Windhoek",
        shortValue: "CAT",
    },
    {
        displayName: "(HST −10:00) America/Adak",
        value: "America/Adak",
        shortValue: "HST",
    },
    {
        displayName: "(AKST −09:00) America/Anchorage",
        value: "America/Anchorage",
        shortValue: "AKST",
    },
    {
        displayName: "(AST −04:00) America/Anguilla",
        value: "America/Anguilla",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/Antigua",
        value: "America/Antigua",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/Aruba",
        value: "America/Aruba",
        shortValue: "AST",
    },
    {
        displayName: "(EST −05:00) America/Atikokan",
        value: "America/Atikokan",
        shortValue: "EST",
    },
    {
        displayName: "(HST −10:00) America/Atka",
        value: "America/Atka",
        shortValue: "HST",
    },
    {
        displayName: "(CST −06:00) America/Bahia_Banderas",
        value: "America/Bahia_Banderas",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Barbados",
        value: "America/Barbados",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Belize",
        value: "America/Belize",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Blanc-Sablon",
        value: "America/Blanc-Sablon",
        shortValue: "AST",
    },
    {
        displayName: "(MST −07:00) America/Boise",
        value: "America/Boise",
        shortValue: "MST",
    },
    {
        displayName: "(MST −07:00) America/Cambridge_Bay",
        value: "America/Cambridge_Bay",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Cancun",
        value: "America/Cancun",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Cayman",
        value: "America/Cayman",
        shortValue: "EST",
    },
    {
        displayName: "(CST −06:00) America/Chicago",
        value: "America/Chicago",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Chihuahua",
        value: "America/Chihuahua",
        shortValue: "CST",
    },
    {
        displayName: "(MST −07:00) America/Ciudad_Juarez",
        value: "America/Ciudad_Juarez",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Coral_Harbour",
        value: "America/Coral_Harbour",
        shortValue: "EST",
    },
    {
        displayName: "(CST −06:00) America/Costa_Rica",
        value: "America/Costa_Rica",
        shortValue: "CST",
    },
    {
        displayName: "(MST −07:00) America/Creston",
        value: "America/Creston",
        shortValue: "MST",
    },
    {
        displayName: "(AST −04:00) America/Curacao",
        value: "America/Curacao",
        shortValue: "AST",
    },
    {
        displayName: "(GMT +00:00) America/Danmarkshavn",
        value: "America/Danmarkshavn",
        shortValue: "GMT",
    },
    {
        displayName: "(MST −07:00) America/Dawson",
        value: "America/Dawson",
        shortValue: "MST",
    },
    {
        displayName: "(MST −07:00) America/Dawson_Creek",
        value: "America/Dawson_Creek",
        shortValue: "MST",
    },
    {
        displayName: "(MST −07:00) America/Denver",
        value: "America/Denver",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Detroit",
        value: "America/Detroit",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Dominica",
        value: "America/Dominica",
        shortValue: "AST",
    },
    {
        displayName: "(MST −07:00) America/Edmonton",
        value: "America/Edmonton",
        shortValue: "MST",
    },
    {
        displayName: "(CST −06:00) America/El_Salvador",
        value: "America/El_Salvador",
        shortValue: "CST",
    },
    {
        displayName: "(PST −08:00) America/Ensenada",
        value: "America/Ensenada",
        shortValue: "PST",
    },
    {
        displayName: "(MST −07:00) America/Fort_Nelson",
        value: "America/Fort_Nelson",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Fort_Wayne",
        value: "America/Fort_Wayne",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Glace_Bay",
        value: "America/Glace_Bay",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/Goose_Bay",
        value: "America/Goose_Bay",
        shortValue: "AST",
    },
    {
        displayName: "(EST −05:00) America/Grand_Turk",
        value: "America/Grand_Turk",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Grenada",
        value: "America/Grenada",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/Guadeloupe",
        value: "America/Guadeloupe",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Guatemala",
        value: "America/Guatemala",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Halifax",
        value: "America/Halifax",
        shortValue: "AST",
    },
    {
        displayName: "(CST −05:00) America/Havana",
        value: "America/Havana",
        shortValue: "CST",
    },
    {
        displayName: "(MST −07:00) America/Hermosillo",
        value: "America/Hermosillo",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Indiana/Indianapolis",
        value: "America/Indiana/Indianapolis",
        shortValue: "EST",
    },
    {
        displayName: "(CST −06:00) America/Indiana/Knox",
        value: "America/Indiana/Knox",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) America/Indiana/Marengo",
        value: "America/Indiana/Marengo",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Indiana/Petersburg",
        value: "America/Indiana/Petersburg",
        shortValue: "EST",
    },
    {
        displayName: "(CST −06:00) America/Indiana/Tell_City",
        value: "America/Indiana/Tell_City",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) America/Indiana/Vevay",
        value: "America/Indiana/Vevay",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Indiana/Vincennes",
        value: "America/Indiana/Vincennes",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Indiana/Winamac",
        value: "America/Indiana/Winamac",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Indianapolis",
        value: "America/Indianapolis",
        shortValue: "EST",
    },
    {
        displayName: "(MST −07:00) America/Inuvik",
        value: "America/Inuvik",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Iqaluit",
        value: "America/Iqaluit",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Jamaica",
        value: "America/Jamaica",
        shortValue: "EST",
    },
    {
        displayName: "(AKST −09:00) America/Juneau",
        value: "America/Juneau",
        shortValue: "AKST",
    },
    {
        displayName: "(EST −05:00) America/Kentucky/Louisville",
        value: "America/Kentucky/Louisville",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Kentucky/Monticello",
        value: "America/Kentucky/Monticello",
        shortValue: "EST",
    },
    {
        displayName: "(CST −06:00) America/Knox_IN",
        value: "America/Knox_IN",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Kralendijk",
        value: "America/Kralendijk",
        shortValue: "AST",
    },
    {
        displayName: "(PST −08:00) America/Los_Angeles",
        value: "America/Los_Angeles",
        shortValue: "PST",
    },
    {
        displayName: "(EST −05:00) America/Louisville",
        value: "America/Louisville",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Lower_Princes",
        value: "America/Lower_Princes",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Managua",
        value: "America/Managua",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Marigot",
        value: "America/Marigot",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/Martinique",
        value: "America/Martinique",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Matamoros",
        value: "America/Matamoros",
        shortValue: "CST",
    },
    {
        displayName: "(MST −07:00) America/Mazatlan",
        value: "America/Mazatlan",
        shortValue: "MST",
    },
    {
        displayName: "(CST −06:00) America/Menominee",
        value: "America/Menominee",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Merida",
        value: "America/Merida",
        shortValue: "CST",
    },
    {
        displayName: "(AKST −09:00) America/Metlakatla",
        value: "America/Metlakatla",
        shortValue: "AKST",
    },
    {
        displayName: "(CST −06:00) America/Mexico_City",
        value: "America/Mexico_City",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Moncton",
        value: "America/Moncton",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Monterrey",
        value: "America/Monterrey",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) America/Montreal",
        value: "America/Montreal",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Montserrat",
        value: "America/Montserrat",
        shortValue: "AST",
    },
    {
        displayName: "(EST −05:00) America/Nassau",
        value: "America/Nassau",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/New_York",
        value: "America/New_York",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Nipigon",
        value: "America/Nipigon",
        shortValue: "EST",
    },
    {
        displayName: "(AKST −09:00) America/Nome",
        value: "America/Nome",
        shortValue: "AKST",
    },
    {
        displayName: "(CST −06:00) America/North_Dakota/Beulah",
        value: "America/North_Dakota/Beulah",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/North_Dakota/Center",
        value: "America/North_Dakota/Center",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/North_Dakota/New_Salem",
        value: "America/North_Dakota/New_Salem",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Ojinaga",
        value: "America/Ojinaga",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) America/Panama",
        value: "America/Panama",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) America/Pangnirtung",
        value: "America/Pangnirtung",
        shortValue: "EST",
    },
    {
        displayName: "(MST −07:00) America/Phoenix",
        value: "America/Phoenix",
        shortValue: "MST",
    },
    {
        displayName: "(EST −05:00) America/Port-au-Prince",
        value: "America/Port-au-Prince",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Port_of_Spain",
        value: "America/Port_of_Spain",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/Puerto_Rico",
        value: "America/Puerto_Rico",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Rainy_River",
        value: "America/Rainy_River",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Rankin_Inlet",
        value: "America/Rankin_Inlet",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Regina",
        value: "America/Regina",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Resolute",
        value: "America/Resolute",
        shortValue: "CST",
    },
    {
        displayName: "(PST −08:00) America/Santa_Isabel",
        value: "America/Santa_Isabel",
        shortValue: "PST",
    },
    {
        displayName: "(AST −04:00) America/Santo_Domingo",
        value: "America/Santo_Domingo",
        shortValue: "AST",
    },
    {
        displayName: "(MST −07:00) America/Shiprock",
        value: "America/Shiprock",
        shortValue: "MST",
    },
    {
        displayName: "(AKST −09:00) America/Sitka",
        value: "America/Sitka",
        shortValue: "AKST",
    },
    {
        displayName: "(AST −04:00) America/St_Barthelemy",
        value: "America/St_Barthelemy",
        shortValue: "AST",
    },
    {
        displayName: "(NST −03:30) America/St_Johns",
        value: "America/St_Johns",
        shortValue: "NST",
    },
    {
        displayName: "(AST −04:00) America/St_Kitts",
        value: "America/St_Kitts",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/St_Lucia",
        value: "America/St_Lucia",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/St_Thomas",
        value: "America/St_Thomas",
        shortValue: "AST",
    },
    {
        displayName: "(AST −04:00) America/St_Vincent",
        value: "America/St_Vincent",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) America/Swift_Current",
        value: "America/Swift_Current",
        shortValue: "CST",
    },
    {
        displayName: "(CST −06:00) America/Tegucigalpa",
        value: "America/Tegucigalpa",
        shortValue: "CST",
    },
    {
        displayName: "(AST −04:00) America/Thule",
        value: "America/Thule",
        shortValue: "AST",
    },
    {
        displayName: "(EST −05:00) America/Thunder_Bay",
        value: "America/Thunder_Bay",
        shortValue: "EST",
    },
    {
        displayName: "(PST −08:00) America/Tijuana",
        value: "America/Tijuana",
        shortValue: "PST",
    },
    {
        displayName: "(EST −05:00) America/Toronto",
        value: "America/Toronto",
        shortValue: "EST",
    },
    {
        displayName: "(AST −04:00) America/Tortola",
        value: "America/Tortola",
        shortValue: "AST",
    },
    {
        displayName: "(PST −08:00) America/Vancouver",
        value: "America/Vancouver",
        shortValue: "PST",
    },
    {
        displayName: "(AST −04:00) America/Virgin",
        value: "America/Virgin",
        shortValue: "AST",
    },
    {
        displayName: "(MST −07:00) America/Whitehorse",
        value: "America/Whitehorse",
        shortValue: "MST",
    },
    {
        displayName: "(CST −06:00) America/Winnipeg",
        value: "America/Winnipeg",
        shortValue: "CST",
    },
    {
        displayName: "(AKST −09:00) America/Yakutat",
        value: "America/Yakutat",
        shortValue: "AKST",
    },
    {
        displayName: "(MST −07:00) America/Yellowknife",
        value: "America/Yellowknife",
        shortValue: "MST",
    },
    {
        displayName: "(AEST +10:00) Antarctica/Macquarie",
        value: "Antarctica/Macquarie",
        shortValue: "AEST",
    },
    {
        displayName: "(NZST +12:00) Antarctica/McMurdo",
        value: "Antarctica/McMurdo",
        shortValue: "NZST",
    },
    {
        displayName: "(NZST +12:00) Antarctica/South_Pole",
        value: "Antarctica/South_Pole",
        shortValue: "NZST",
    },
    {
        displayName: "(CET +01:00) Arctic/Longyearbyen",
        value: "Arctic/Longyearbyen",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Asia/Beirut",
        value: "Asia/Beirut",
        shortValue: "EET",
    },
    {
        displayName: "(IST +05:30) Asia/Calcutta",
        value: "Asia/Calcutta",
        shortValue: "IST",
    },
    {
        displayName: "(CST +08:00) Asia/Chongqing",
        value: "Asia/Chongqing",
        shortValue: "CST",
    },
    {
        displayName: "(CST +08:00) Asia/Chungking",
        value: "Asia/Chungking",
        shortValue: "CST",
    },
    {
        displayName: "(EET +02:00) Asia/Famagusta",
        value: "Asia/Famagusta",
        shortValue: "EET",
    },
    {
        displayName: "(EET +02:00) Asia/Gaza",
        value: "Asia/Gaza",
        shortValue: "EET",
    },
    {
        displayName: "(CST +08:00) Asia/Harbin",
        value: "Asia/Harbin",
        shortValue: "CST",
    },
    {
        displayName: "(EET +02:00) Asia/Hebron",
        value: "Asia/Hebron",
        shortValue: "EET",
    },
    {
        displayName: "(HKT +08:00) Asia/Hong_Kong",
        value: "Asia/Hong_Kong",
        shortValue: "HKT",
    },
    {
        displayName: "(WIB +07:00) Asia/Jakarta",
        value: "Asia/Jakarta",
        shortValue: "WIB",
    },
    {
        displayName: "(WIT +09:00) Asia/Jayapura",
        value: "Asia/Jayapura",
        shortValue: "WIT",
    },
    {
        displayName: "(IST +02:00) Asia/Jerusalem",
        value: "Asia/Jerusalem",
        shortValue: "IST",
    },
    {
        displayName: "(PKT +05:00) Asia/Karachi",
        value: "Asia/Karachi",
        shortValue: "PKT",
    },
    {
        displayName: "(IST +05:30) Asia/Kolkata",
        value: "Asia/Kolkata",
        shortValue: "IST",
    },
    {
        displayName: "(CST +08:00) Asia/Macao",
        value: "Asia/Macao",
        shortValue: "CST",
    },
    {
        displayName: "(CST +08:00) Asia/Macau",
        value: "Asia/Macau",
        shortValue: "CST",
    },
    {
        displayName: "(WITA +08:00) Asia/Makassar",
        value: "Asia/Makassar",
        shortValue: "WITA",
    },
    {
        displayName: "(PST +08:00) Asia/Manila",
        value: "Asia/Manila",
        shortValue: "PST",
    },
    {
        displayName: "(EET +02:00) Asia/Nicosia",
        value: "Asia/Nicosia",
        shortValue: "EET",
    },
    {
        displayName: "(WIB +07:00) Asia/Pontianak",
        value: "Asia/Pontianak",
        shortValue: "WIB",
    },
    {
        displayName: "(KST +09:00) Asia/Pyongyang",
        value: "Asia/Pyongyang",
        shortValue: "KST",
    },
    {
        displayName: "(KST +09:00) Asia/Seoul",
        value: "Asia/Seoul",
        shortValue: "KST",
    },
    {
        displayName: "(CST +08:00) Asia/Shanghai",
        value: "Asia/Shanghai",
        shortValue: "CST",
    },
    {
        displayName: "(CST +08:00) Asia/Taipei",
        value: "Asia/Taipei",
        shortValue: "CST",
    },
    {
        displayName: "(IST +02:00) Asia/Tel_Aviv",
        value: "Asia/Tel_Aviv",
        shortValue: "IST",
    },
    {
        displayName: "(JST +09:00) Asia/Tokyo",
        value: "Asia/Tokyo",
        shortValue: "JST",
    },
    {
        displayName: "(WITA +08:00) Asia/Ujung_Pandang",
        value: "Asia/Ujung_Pandang",
        shortValue: "WITA",
    },
    {
        displayName: "(AST −04:00) Atlantic/Bermuda",
        value: "Atlantic/Bermuda",
        shortValue: "AST",
    },
    {
        displayName: "(WET +00:00) Atlantic/Canary",
        value: "Atlantic/Canary",
        shortValue: "WET",
    },
    {
        displayName: "(WET +00:00) Atlantic/Faeroe",
        value: "Atlantic/Faeroe",
        shortValue: "WET",
    },
    {
        displayName: "(WET +00:00) Atlantic/Faroe",
        value: "Atlantic/Faroe",
        shortValue: "WET",
    },
    {
        displayName: "(CET +01:00) Atlantic/Jan_Mayen",
        value: "Atlantic/Jan_Mayen",
        shortValue: "CET",
    },
    {
        displayName: "(WET +00:00) Atlantic/Madeira",
        value: "Atlantic/Madeira",
        shortValue: "WET",
    },
    {
        displayName: "(GMT +00:00) Atlantic/Reykjavik",
        value: "Atlantic/Reykjavik",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Atlantic/St_Helena",
        value: "Atlantic/St_Helena",
        shortValue: "GMT",
    },
    {
        displayName: "(AEST +10:00) Australia/ACT",
        value: "Australia/ACT",
        shortValue: "AEST",
    },
    {
        displayName: "(ACST +09:30) Australia/Adelaide",
        value: "Australia/Adelaide",
        shortValue: "ACST",
    },
    {
        displayName: "(AEST +10:00) Australia/Brisbane",
        value: "Australia/Brisbane",
        shortValue: "AEST",
    },
    {
        displayName: "(ACST +09:30) Australia/Broken_Hill",
        value: "Australia/Broken_Hill",
        shortValue: "ACST",
    },
    {
        displayName: "(AEST +10:00) Australia/Canberra",
        value: "Australia/Canberra",
        shortValue: "AEST",
    },
    {
        displayName: "(AEST +10:00) Australia/Currie",
        value: "Australia/Currie",
        shortValue: "AEST",
    },
    {
        displayName: "(ACST +09:30) Australia/Darwin",
        value: "Australia/Darwin",
        shortValue: "ACST",
    },
    {
        displayName: "(AEST +10:00) Australia/Hobart",
        value: "Australia/Hobart",
        shortValue: "AEST",
    },
    {
        displayName: "(AEST +10:00) Australia/Lindeman",
        value: "Australia/Lindeman",
        shortValue: "AEST",
    },
    {
        displayName: "(AEST +10:00) Australia/Melbourne",
        value: "Australia/Melbourne",
        shortValue: "AEST",
    },
    {
        displayName: "(ACST +09:30) Australia/North",
        value: "Australia/North",
        shortValue: "ACST",
    },
    {
        displayName: "(AEST +10:00) Australia/NSW",
        value: "Australia/NSW",
        shortValue: "AEST",
    },
    {
        displayName: "(AWST +08:00) Australia/Perth",
        value: "Australia/Perth",
        shortValue: "AWST",
    },
    {
        displayName: "(AEST +10:00) Australia/Queensland",
        value: "Australia/Queensland",
        shortValue: "AEST",
    },
    {
        displayName: "(ACST +09:30) Australia/South",
        value: "Australia/South",
        shortValue: "ACST",
    },
    {
        displayName: "(AEST +10:00) Australia/Sydney",
        value: "Australia/Sydney",
        shortValue: "AEST",
    },
    {
        displayName: "(AEST +10:00) Australia/Tasmania",
        value: "Australia/Tasmania",
        shortValue: "AEST",
    },
    {
        displayName: "(AEST +10:00) Australia/Victoria",
        value: "Australia/Victoria",
        shortValue: "AEST",
    },
    {
        displayName: "(AWST +08:00) Australia/West",
        value: "Australia/West",
        shortValue: "AWST",
    },
    {
        displayName: "(ACST +09:30) Australia/Yancowinna",
        value: "Australia/Yancowinna",
        shortValue: "ACST",
    },
    {
        displayName: "(AST −04:00) Canada/Atlantic",
        value: "Canada/Atlantic",
        shortValue: "AST",
    },
    {
        displayName: "(CST −06:00) Canada/Central",
        value: "Canada/Central",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) Canada/Eastern",
        value: "Canada/Eastern",
        shortValue: "EST",
    },
    {
        displayName: "(MST −07:00) Canada/Mountain",
        value: "Canada/Mountain",
        shortValue: "MST",
    },
    {
        displayName: "(NST −03:30) Canada/Newfoundland",
        value: "Canada/Newfoundland",
        shortValue: "NST",
    },
    {
        displayName: "(PST −08:00) Canada/Pacific",
        value: "Canada/Pacific",
        shortValue: "PST",
    },
    {
        displayName: "(CST −06:00) Canada/Saskatchewan",
        value: "Canada/Saskatchewan",
        shortValue: "CST",
    },
    {
        displayName: "(MST −07:00) Canada/Yukon",
        value: "Canada/Yukon",
        shortValue: "MST",
    },
    {
        displayName: "(CET +01:00) CET",
        value: "CET",
        shortValue: "CET",
    },
    {
        displayName: "(CST −06:00) CST6CDT",
        value: "CST6CDT",
        shortValue: "CST",
    },
    {
        displayName: "(CST −05:00) Cuba",
        value: "Cuba",
        shortValue: "CST",
    },
    {
        displayName: "(EET +02:00) EET",
        value: "EET",
        shortValue: "EET",
    },
    {
        displayName: "(EET +02:00) Egypt",
        value: "Egypt",
        shortValue: "EET",
    },
    {
        displayName: "(GMT +00:00) Eire",
        value: "Eire",
        shortValue: "GMT",
    },
    {
        displayName: "(EST −05:00) EST",
        value: "EST",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) EST5EDT",
        value: "EST5EDT",
        shortValue: "EST",
    },
    {
        displayName: "(GMT +00:00) Etc/GMT",
        value: "Etc/GMT",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Etc/GMT+0",
        value: "Etc/GMT+0",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Etc/GMT-0",
        value: "Etc/GMT-0",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Etc/GMT0",
        value: "Etc/GMT0",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Etc/Greenwich",
        value: "Etc/Greenwich",
        shortValue: "GMT",
    },
    {
        displayName: "(UTC +00:00) Etc/UCT",
        value: "Etc/UCT",
        shortValue: "UTC",
    },
    {
        displayName: "(UTC +00:00) Etc/Universal",
        value: "Etc/Universal",
        shortValue: "UTC",
    },
    {
        displayName: "(UTC +00:00) Etc/UTC",
        value: "Etc/UTC",
        shortValue: "UTC",
    },
    {
        displayName: "(UTC +00:00) Etc/Zulu",
        value: "Etc/Zulu",
        shortValue: "UTC",
    },
    {
        displayName: "(CET +01:00) Europe/Amsterdam",
        value: "Europe/Amsterdam",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Andorra",
        value: "Europe/Andorra",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Athens",
        value: "Europe/Athens",
        shortValue: "EET",
    },
    {
        displayName: "(GMT +00:00) Europe/Belfast",
        value: "Europe/Belfast",
        shortValue: "GMT",
    },
    {
        displayName: "(CET +01:00) Europe/Belgrade",
        value: "Europe/Belgrade",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Berlin",
        value: "Europe/Berlin",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Bratislava",
        value: "Europe/Bratislava",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Brussels",
        value: "Europe/Brussels",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Bucharest",
        value: "Europe/Bucharest",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Budapest",
        value: "Europe/Budapest",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Busingen",
        value: "Europe/Busingen",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Chisinau",
        value: "Europe/Chisinau",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Copenhagen",
        value: "Europe/Copenhagen",
        shortValue: "CET",
    },
    {
        displayName: "(GMT +00:00) Europe/Dublin",
        value: "Europe/Dublin",
        shortValue: "GMT",
    },
    {
        displayName: "(CET +01:00) Europe/Gibraltar",
        value: "Europe/Gibraltar",
        shortValue: "CET",
    },
    {
        displayName: "(GMT +00:00) Europe/Guernsey",
        value: "Europe/Guernsey",
        shortValue: "GMT",
    },
    {
        displayName: "(EET +02:00) Europe/Helsinki",
        value: "Europe/Helsinki",
        shortValue: "EET",
    },
    {
        displayName: "(GMT +00:00) Europe/Isle_of_Man",
        value: "Europe/Isle_of_Man",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Europe/Jersey",
        value: "Europe/Jersey",
        shortValue: "GMT",
    },
    {
        displayName: "(EET +02:00) Europe/Kaliningrad",
        value: "Europe/Kaliningrad",
        shortValue: "EET",
    },
    {
        displayName: "(EET +02:00) Europe/Kiev",
        value: "Europe/Kiev",
        shortValue: "EET",
    },
    {
        displayName: "(MSK +03:00) Europe/Kirov",
        value: "Europe/Kirov",
        shortValue: "MSK",
    },
    {
        displayName: "(EET +02:00) Europe/Kyiv",
        value: "Europe/Kyiv",
        shortValue: "EET",
    },
    {
        displayName: "(WET +00:00) Europe/Lisbon",
        value: "Europe/Lisbon",
        shortValue: "WET",
    },
    {
        displayName: "(CET +01:00) Europe/Ljubljana",
        value: "Europe/Ljubljana",
        shortValue: "CET",
    },
    {
        displayName: "(GMT +00:00) Europe/London",
        value: "Europe/London",
        shortValue: "GMT",
    },
    {
        displayName: "(CET +01:00) Europe/Luxembourg",
        value: "Europe/Luxembourg",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Madrid",
        value: "Europe/Madrid",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Malta",
        value: "Europe/Malta",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Mariehamn",
        value: "Europe/Mariehamn",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Monaco",
        value: "Europe/Monaco",
        shortValue: "CET",
    },
    {
        displayName: "(MSK +03:00) Europe/Moscow",
        value: "Europe/Moscow",
        shortValue: "MSK",
    },
    {
        displayName: "(EET +02:00) Europe/Nicosia",
        value: "Europe/Nicosia",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Oslo",
        value: "Europe/Oslo",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Paris",
        value: "Europe/Paris",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Podgorica",
        value: "Europe/Podgorica",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Prague",
        value: "Europe/Prague",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Riga",
        value: "Europe/Riga",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Rome",
        value: "Europe/Rome",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/San_Marino",
        value: "Europe/San_Marino",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Sarajevo",
        value: "Europe/Sarajevo",
        shortValue: "CET",
    },
    {
        displayName: "(MSK +03:00) Europe/Simferopol",
        value: "Europe/Simferopol",
        shortValue: "MSK",
    },
    {
        displayName: "(CET +01:00) Europe/Skopje",
        value: "Europe/Skopje",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Sofia",
        value: "Europe/Sofia",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Stockholm",
        value: "Europe/Stockholm",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Tallinn",
        value: "Europe/Tallinn",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Tirane",
        value: "Europe/Tirane",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Tiraspol",
        value: "Europe/Tiraspol",
        shortValue: "EET",
    },
    {
        displayName: "(EET +02:00) Europe/Uzhgorod",
        value: "Europe/Uzhgorod",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Vaduz",
        value: "Europe/Vaduz",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Vatican",
        value: "Europe/Vatican",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Vienna",
        value: "Europe/Vienna",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Vilnius",
        value: "Europe/Vilnius",
        shortValue: "EET",
    },
    {
        displayName: "(MSK +03:00) Europe/Volgograd",
        value: "Europe/Volgograd",
        shortValue: "MSK",
    },
    {
        displayName: "(CET +01:00) Europe/Warsaw",
        value: "Europe/Warsaw",
        shortValue: "CET",
    },
    {
        displayName: "(CET +01:00) Europe/Zagreb",
        value: "Europe/Zagreb",
        shortValue: "CET",
    },
    {
        displayName: "(EET +02:00) Europe/Zaporozhye",
        value: "Europe/Zaporozhye",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) Europe/Zurich",
        value: "Europe/Zurich",
        shortValue: "CET",
    },
    {
        displayName: "(GMT +00:00) GB",
        value: "GB",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) GB-Eire",
        value: "GB-Eire",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) GMT",
        value: "GMT",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) GMT+0",
        value: "GMT+0",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) GMT-0",
        value: "GMT-0",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) GMT0",
        value: "GMT0",
        shortValue: "GMT",
    },
    {
        displayName: "(GMT +00:00) Greenwich",
        value: "Greenwich",
        shortValue: "GMT",
    },
    {
        displayName: "(HKT +08:00) Hongkong",
        value: "Hongkong",
        shortValue: "HKT",
    },
    {
        displayName: "(HST −10:00) HST",
        value: "HST",
        shortValue: "HST",
    },
    {
        displayName: "(GMT +00:00) Iceland",
        value: "Iceland",
        shortValue: "GMT",
    },
    {
        displayName: "(EAT +03:00) Indian/Antananarivo",
        value: "Indian/Antananarivo",
        shortValue: "EAT",
    },
    {
        displayName: "(EAT +03:00) Indian/Comoro",
        value: "Indian/Comoro",
        shortValue: "EAT",
    },
    {
        displayName: "(EAT +03:00) Indian/Mayotte",
        value: "Indian/Mayotte",
        shortValue: "EAT",
    },
    {
        displayName: "(IST +02:00) Israel",
        value: "Israel",
        shortValue: "IST",
    },
    {
        displayName: "(EST −05:00) Jamaica",
        value: "Jamaica",
        shortValue: "EST",
    },
    {
        displayName: "(JST +09:00) Japan",
        value: "Japan",
        shortValue: "JST",
    },
    {
        displayName: "(EET +02:00) Libya",
        value: "Libya",
        shortValue: "EET",
    },
    {
        displayName: "(CET +01:00) MET",
        value: "MET",
        shortValue: "CET",
    },
    {
        displayName: "(PST −08:00) Mexico/BajaNorte",
        value: "Mexico/BajaNorte",
        shortValue: "PST",
    },
    {
        displayName: "(MST −07:00) Mexico/BajaSur",
        value: "Mexico/BajaSur",
        shortValue: "MST",
    },
    {
        displayName: "(CST −06:00) Mexico/General",
        value: "Mexico/General",
        shortValue: "CST",
    },
    {
        displayName: "(MST −07:00) MST",
        value: "MST",
        shortValue: "MST",
    },
    {
        displayName: "(MST −07:00) MST7MDT",
        value: "MST7MDT",
        shortValue: "MST",
    },
    {
        displayName: "(MST −07:00) Navajo",
        value: "Navajo",
        shortValue: "MST",
    },
    {
        displayName: "(NZST +12:00) NZ",
        value: "NZ",
        shortValue: "NZST",
    },
    {
        displayName: "(NZST +12:00) Pacific/Auckland",
        value: "Pacific/Auckland",
        shortValue: "NZST",
    },
    {
        displayName: "(ChST +10:00) Pacific/Guam",
        value: "Pacific/Guam",
        shortValue: "ChST",
    },
    {
        displayName: "(HST −10:00) Pacific/Honolulu",
        value: "Pacific/Honolulu",
        shortValue: "HST",
    },
    {
        displayName: "(HST −10:00) Pacific/Johnston",
        value: "Pacific/Johnston",
        shortValue: "HST",
    },
    {
        displayName: "(SST −11:00) Pacific/Midway",
        value: "Pacific/Midway",
        shortValue: "SST",
    },
    {
        displayName: "(SST −11:00) Pacific/Pago_Pago",
        value: "Pacific/Pago_Pago",
        shortValue: "SST",
    },
    {
        displayName: "(ChST +10:00) Pacific/Saipan",
        value: "Pacific/Saipan",
        shortValue: "ChST",
    },
    {
        displayName: "(SST −11:00) Pacific/Samoa",
        value: "Pacific/Samoa",
        shortValue: "SST",
    },
    {
        displayName: "(CET +01:00) Poland",
        value: "Poland",
        shortValue: "CET",
    },
    {
        displayName: "(WET +00:00) Portugal",
        value: "Portugal",
        shortValue: "WET",
    },
    {
        displayName: "(CST +08:00) PRC",
        value: "PRC",
        shortValue: "CST",
    },
    {
        displayName: "(PST −08:00) PST8PDT",
        value: "PST8PDT",
        shortValue: "PST",
    },
    {
        displayName: "(CST +08:00) ROC",
        value: "ROC",
        shortValue: "CST",
    },
    {
        displayName: "(KST +09:00) ROK",
        value: "ROK",
        shortValue: "KST",
    },
    {
        displayName: "(UTC +00:00) UCT",
        value: "UCT",
        shortValue: "UTC",
    },
    {
        displayName: "(UTC +00:00) Universal",
        value: "Universal",
        shortValue: "UTC",
    },
    {
        displayName: "(AKST −09:00) US/Alaska",
        value: "US/Alaska",
        shortValue: "AKST",
    },
    {
        displayName: "(HST −10:00) US/Aleutian",
        value: "US/Aleutian",
        shortValue: "HST",
    },
    {
        displayName: "(MST −07:00) US/Arizona",
        value: "US/Arizona",
        shortValue: "MST",
    },
    {
        displayName: "(CST −06:00) US/Central",
        value: "US/Central",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) US/East-Indiana",
        value: "US/East-Indiana",
        shortValue: "EST",
    },
    {
        displayName: "(EST −05:00) US/Eastern",
        value: "US/Eastern",
        shortValue: "EST",
    },
    {
        displayName: "(HST −10:00) US/Hawaii",
        value: "US/Hawaii",
        shortValue: "HST",
    },
    {
        displayName: "(CST −06:00) US/Indiana-Starke",
        value: "US/Indiana-Starke",
        shortValue: "CST",
    },
    {
        displayName: "(EST −05:00) US/Michigan",
        value: "US/Michigan",
        shortValue: "EST",
    },
    {
        displayName: "(MST −07:00) US/Mountain",
        value: "US/Mountain",
        shortValue: "MST",
    },
    {
        displayName: "(PST −08:00) US/Pacific",
        value: "US/Pacific",
        shortValue: "PST",
    },
    {
        displayName: "(SST −11:00) US/Samoa",
        value: "US/Samoa",
        shortValue: "SST",
    },
    {
        displayName: "(UTC +00:00) UTC",
        value: "UTC",
        shortValue: "UTC",
    },
    {
        displayName: "(MSK +03:00) W-SU",
        value: "W-SU",
        shortValue: "MSK",
    },
    {
        displayName: "(WET +00:00) WET",
        value: "WET",
        shortValue: "WET",
    },
    {
        displayName: "(UTC +00:00) Zulu",
        value: "Zulu",
        shortValue: "UTC",
    },
];
// custom Validation for All Fields
export function fnCheckValidationOfObject(obj) {
    let IsValid = true;
    if (obj.errors !== null) {
        if (obj.errors.ValidationRules) {
            for (let i = 0; i < obj.errors.ValidationRules.length; i++) {
                obj.errors[obj.errors.ValidationRules[i].FieldName] = "";
            }

            for (let i = 0; i < obj.errors.ValidationRules.length; i++) {
                let objRules = obj.errors.ValidationRules[i];

                if (objRules !== null) {
                    // Required validation :
                    if (objRules.ValidationType.toLowerCase() === "required") {
                        if (
                            obj[objRules.FieldName] === "" ||
                            obj[objRules.FieldName] === null ||
                            obj[objRules.FieldName] === undefined
                        ) {
                            IsValid = false;
                            obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                        }
                    }

                    if (
                        obj[objRules.FieldName] !== "" &&
                        obj[objRules.FieldName] !== null &&
                        obj[objRules.FieldName] !== undefined
                    ) {
                        //  Range validation
                        if (objRules.ValidationType.toLowerCase() === "range") {
                            if (objRules.FieldName === "old_password") {
                                if (obj.old_password.length < 6) {
                                    IsValid = false;
                                    obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                                }
                            }
                            if (objRules.FieldName === "new_password") {
                                if (obj.new_password.length < 6) {
                                    IsValid = false;
                                    obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                                }
                            }
                        }

                        // Masking Validation
                        if (objRules.ValidationType.toLowerCase() === "mobile-mask") {
                            // if (!obj[objRules.FieldName].toString().match(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/)) {
                            if (!obj[objRules.FieldName].toString().match(/^[0-9]{10}$/)) {
                                IsValid = false;
                                obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                            }
                        }

                        // Email Validation
                        if (
                            obj.errors[objRules.FieldName] === "" &&
                            objRules.ValidationType.toLowerCase() === "email"
                        ) {
                            var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                            if (!obj[objRules.FieldName].toString().match(mailformat)) {
                                IsValid = false;
                                obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                            }
                        }

                        //  Number validation
                        if (
                            objRules.ValidationType.toLowerCase() === "number" &&
                            obj.errors[objRules.FieldName] === ""
                        ) {
                            var mailformat = /^[0-9]/;
                            if (!obj[objRules.FieldName].toString().match(mailformat)) {
                                IsValid = false;
                                obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                            }
                        }

                        //  Compare Field Value

                        if (
                            obj.errors[objRules.FieldName] === "new_password" &&
                            obj.errors[objRules.CompareFieldName] ===
                            "confirm_new_password" &&
                            objRules.ValidationType.toLowerCase() === "comparefieldvalue"
                        ) {
                            // var mailformat = /^[0-9]*$/;

                            if (obj[objRules.FieldName] !== obj[objRules.CompareFieldName]) {
                                IsValid = false;
                                obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                            }
                        }

                        //date validation
                        if (objRules.ValidationType.toLowerCase() === "date") {
                            if (moment(obj[objRules.FieldName]) <= moment("1900-01-01")) {
                                IsValid = false;
                                obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                            }
                        }
                        if (objRules.ValidationType.toLowerCase() === "checkbox") {
                            if (obj[objRules.FieldName].length === 0) {
                                IsValid = false;
                                obj.errors[objRules.FieldName] = objRules.ValidationMessage;
                            }
                        }
                    }
                }
            }
        }
    }

    setTimeout(() => {
        let ApplyClass =
            document.getElementsByClassName(`error-border-line`).length !== 0
                ? "error-border-line"
                : "is-invalid";
        FocusOnValidationField(ApplyClass);
    }, 500);

    return { isValid: IsValid, obj: obj };
}
export function fnCommonValueFill(value, tag, obj, mainState, page) {
    let updatedValue = { ...obj };
    if (updatedValue?.errors !== null) {
        if (value !== "") {
            updatedValue[tag] = value;
            updatedValue.errors = {
                ...updatedValue?.errors,
                [tag]: "",
            };
        }
    }
    mainState(updatedValue);
}
function FileSizeMBGB(fileSizeInBytes, decimalPlaces = 2) {
    if (!fileSizeInBytes) return "0";
    const MB = 1024 * 1024;
    const GB = 1024 * 1024 * 1024;
    let formattedSize;
    let unit;
    if (fileSizeInBytes >= GB) {
        formattedSize = (fileSizeInBytes / GB).toFixed(decimalPlaces);
        unit = "GB";
    } else {
        formattedSize = (fileSizeInBytes / MB).toFixed(decimalPlaces);
        unit = "MB";
    }
    return `${formattedSize} ${unit}`;
}
export function getItem(key) {
    let dataValues = localStorage.getItem(key) || "";
    return dataValues;
}
export function getAllTimeZoneList() {
    const timeZones = moment.tz.names();
    const timeZoneSet = new Set();

    const timeZoneList = timeZones.map((zone) => {
        const offset = moment.tz(zone).utcOffset(); // Get offset in minutes
        const hours = Math.floor(Math.abs(offset) / 60);
        const minutes = Math.abs(offset) % 60;
        const sign = offset >= 0 ? "+" : "-";
        const formattedOffset = `GMT${sign}${String(hours).padStart(
            2,
            "0"
        )}:${String(minutes).padStart(2, "0")}`;
        const zoneName = moment.tz(zone).zoneAbbr(); // Get the abbreviation

        const timeZoneString = `${formattedOffset} ${zoneName} - ${zone}`;

        // Add to the set to ensure uniqueness
        timeZoneSet.add(timeZoneString);
        return timeZoneString;
    });

    // Convert the set back to an array
    return Array.from(timeZoneSet);
}
function getHeadersFromData() {
    return {
        "Content-Type": "multipart/form-data",
        accept: "*/*",
        timezone: localTimezone,
        Authorization: "Bearer " + getItem("Token"),
        requesturl: window.location.origin,
    };
}
function getHeaders() {
    return {
        "Content-Type": "application/json",
        accept: "*/*",
        timezone: localTimezone,
        Authorization: "Bearer " + getItem("Token"),
        requesturl: window.location.origin,
    };
}
// create Guid
function createGuid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-4" +
        S4().substr(0, 3) +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
    ).toLowerCase();
}
// Crypto convert for userdata
function setItem(key, strString) {
    let CryptoJS = require("crypto-js");
    localStorage.setItem(key, CryptoJS.AES.encrypt(strString, cryptoKey));
}
// decrypt data
function getDecryptData(key) {
    let CryptoJS = require("crypto-js");
    let dataValues = localStorage.getItem(key) || "";
    let dataStr = "";
    if (dataValues !== "") {
        var bytes = CryptoJS.AES.decrypt(dataValues, cryptoKey);
        dataStr = bytes.toString(CryptoJS.enc.Utf8);
    }
    return dataStr;
}
function getDateInFormatCustom(date, timezone, format) {
    if (format) {
    } else {
        format = "MM/DD/yyyy HH:mm";
    }

    if (date !== null && date !== "" && date !== undefined) {
        // if (date !== null && date !== "" && date !== undefined)
        //   return moment(date).format("HH:mm");
        // else return "";
        const utcTime = moment.utc(date, "YYYY-MM-DD HH:mm:ss");
        const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Convert UTC time to local time
        const localTime = utcTime.tz(timezone == null ? localTimezone : timezone);
        // Format the local time as a string
        const formattedLocalTime = localTime?.format(format);
        return formattedLocalTime;
    }
}
function getTimeInFormat(date, timezone) {
    if (
        date !== null &&
        date !== "" &&
        date !== undefined
        // timezone !== undefined
    ) {
        // if (date !== null && date !== "" && date !== undefined)
        //   return moment(date).format("HH:mm");
        // else return "";
        const utcTime = moment.utc(date, "YYYY-MM-DD HH:mm:ss");
        const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Convert UTC time to local time
        const localTime = utcTime.tz(
            timezone === "" || timezone === undefined ? localTimezone : timezone
        );
        // Format the local time as a string
        const formattedLocalTime = localTime.format("HH:mm:ss");
        return formattedLocalTime;
    }
}
function NewUTCFormat(date) {
    if (date !== null && date !== "" && date !== undefined) {
        const dateToConvert = new Date(date);
        const utcDate = new Date(
            dateToConvert.getUTCFullYear(),
            dateToConvert.getUTCMonth(),
            dateToConvert.getUTCDate(),
            dateToConvert.getUTCHours(),
            dateToConvert.getUTCMinutes(),
            dateToConvert.getUTCSeconds()
        );

        const utcDateString = utcDate.toISOString();

        return utcDateString;
    }
}
function BasicUTCTime(date) {
    if (date !== null && date !== "" && date !== undefined) {
        const dateToConvert = new Date(date);
        const utcDate = new Date(
            Date.UTC(
                dateToConvert.getUTCFullYear(),
                dateToConvert.getUTCMonth(),
                dateToConvert.getUTCDate(),
                dateToConvert.getUTCHours(),
                dateToConvert.getUTCMinutes(),
                dateToConvert.getUTCSeconds()
            )
        );

        const utcTimeString = utcDate.toISOString().split("T")[1]; // Extracting only the time part
        return utcTimeString;
    }
}
function getAgo(date) {
    if (date !== null && date !== "" && date !== undefined) {
        // date = new Date(date);
        const utcTime = moment.utc(date);
        const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const localTime = utcTime.tz(localTimezone);
        // const formattedLocalTime = localTime.format("dddd DD MMM YYYY | HH:mm");
        return moment(new Date(localTime)).fromNow();
    }
}
function HidePassword(password) {
    let str = "";
    if (password !== "" && password !== null && password !== undefined) {
        for (let i = 0; i < password.length; i++) {
            str = str + "*";
        }
    }
    return str;
}
function getStatusUI(status) {
    if (status === "end") {
        status = (
            <span className="completed" style={{ color: "green" }}>
                Completed
            </span>
        );
    } else if (status === "start") {
        status = (
            <span className="inprogress" style={{ color: "gray" }}>
                Inprogress
            </span>
        );
    } else if (status === "failed") {
        status = (
            <span className="failed" style={{ color: "red" }}>
                Failed
            </span>
        );
    }
    return status;
}
// function calculateDuration(startdate, enddate) {
//   if (startdate && enddate) {
//     const dateB = moment.utc(enddate, "YYYY-MM-DD HH:mm:ss"); //moment(enddate);
//     const dateC = moment.utc(startdate, "YYYY-MM-DD HH:mm:ss"); //moment(startdate);
//     return dateB.diff(dateC, "seconds");
//   } else {
//     return 0;
//   }

//   //const dateB = moment(enddate);
//   //const dateC = moment(startdate);
//   //return dateB.diff(dateC, "seconds");
// }
function calculateDuration(startdate, enddate) {
    if (startdate && enddate) {
        const dateB = moment.utc(enddate, "YYYY-MM-DD HH:mm:ss");
        const dateC = moment.utc(startdate, "YYYY-MM-DD HH:mm:ss");

        const totalSeconds = dateB.diff(dateC, "seconds");

        if (totalSeconds <= 60) {
            return `${totalSeconds} sec`;
        } else if (totalSeconds < 3600) {
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;
            return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
                2,
                "0"
            )} min`;
        } else {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
                2,
                "0"
            )}:${String(seconds).padStart(2, "0")} hrs`;
        }
    } else {
        return "00 sec";
    }
}
function calculateDurationSec(Seconds) {
    if (Seconds) {
        // const dateB = moment.utc(enddate, "YYYY-MM-DD HH:mm:ss");
        // const dateC = moment.utc(startdate, "YYYY-MM-DD HH:mm:ss");

        // const totalSeconds = dateB.diff(dateC, "seconds");

        if (Seconds <= 60) {
            return `${Seconds} sec`;
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
                2,
                "0"
            )} min`;
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;
            return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
                2,
                "0"
            )}:${String(seconds).padStart(2, "0")} hrs`;
        }
    } else {
        return "00 sec";
    }
}

function convertTimeToLocal(date) {
    let timeFormate = moment.utc(date);
    let formatedTime = timeFormate.local().format("HH:mm");
    return formatedTime;
}

function convertTimeToLocal12Formate(date) {
    let timeFormate = moment.utc(date);
    let formatedTime = timeFormate.local().format("hh:mm A");
    return formatedTime;
}


function convertTimeToLocal12ForAsID(date) {
    let timeFormate = moment.utc(date);
    let formatedTime = timeFormate.local().format("hA");
    return formatedTime;
}

function convertDateToLocal(date) {
    if (date !== "" && date !== null && date !== undefined) {
        let timeFormate = moment.utc(date);
        let formatedTime = timeFormate.local().format("MM/DD/YYYY");
        return formatedTime;
    }
}
function NumberCalculateValue(value) {
    if (value !== "" && value !== undefined && value !== null) {
        if (value >= 1000) {
            return (value / 1000).toFixed(value % 1000 === 0 ? 0 : 1) + "K";
        } else {
            return value.toString();
        }
    }
    return "";
}
function truncateText(text, length) {
    return text?.length > length ? text?.substring(0, length) + "..." : text;
}
function stripHTML(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
}
function IsValidJson(json) {
    try {
        JSON.parse(json);
        return true;
    } catch (e) {
        return false;
    }
}
function MachineStatus(status) {
    if (status !== "" && status !== null && status !== undefined) {
        if (status === "In Process") {
            return "in-process";
        } else if (status === "Pending") {
            return "pending";
        } else if (status === "Rejected") {
            return "rejected";
        } else if (status === "Publish") {
            return "publish";
        } else if (status === "Deprecated") {
            return "deprecated";
        } else if (status === "Discontinued") {
            return "discontinued";
        }
    }
}
function GetRoleAccess(data, UserRoleRight) {
    return UserRoleRight?.find((item) => item?.rightname === data);
}
function GetRoleAccessDetails(data, UserRoleRight, type) {
    return UserRoleRight?.find(
        (item) => item?.rolename === data && item?.rightname === type
    );
}
function GetCurrentDate() {
    return moment().format("YYYY-MM-DD");
}
function getDateInDBFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return moment(date).format("YYYY-MM-DD");
    else return "";
}

function getDateTimeInDBFormat(date) {
    if (date !== null && date !== "" && date !== undefined)
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
    else return "";
}

function getWalkthroughDetail() {
    let data = getDecryptData("walkthrough");
    let finalData = "";
    if (data) {
        finalData = JSON.parse(data);
    }
    return finalData;
}
function clearLocalStorage() {
    localStorage.removeItem("Token");
    localStorage.removeItem("UserInfo");
    localStorage.removeItem("UserRoleRight");
    localStorage.removeItem("Organization");
}
export function isDomainCheck(key) {
    //you have to pass compulsary proper spelling like 'DataFactory',"Developer"
    if (key !== "" && key !== null && key !== undefined) {
        if (key === "DataFactory") {
            return window.location.href.includes(process.env.REACT_APP_WORKFLOW);
        } else if (key === "Developer") {
            return window.location.href.includes(process.env.REACT_APP_DEV);
        }
    }
}

function getStatus(statusValue) {
    let status = <div></div>;
    if (statusValue) {
        if (statusValue === "Draft") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#9A9A9A"} /> */}
                    <span className="common-status-box draft-status"></span>
                    <span className="fw600 draft-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Active" || statusValue === "Success") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#008000"} /> */}
                    <span className="common-status-box active-status"></span>
                    <span className="fw600 active-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Open") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#008000"} /> */}
                    <span className="common-status-box active-status"></span>
                    <span className="fw600 active-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Resume") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#007BFF"} /> */}
                    <span className="common-status-box resume-status"></span>
                    <span className="fw600 resume-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Suspend") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#FFA500"} /> */}
                    <span className="common-status-box pending-status"></span>
                    <span className="fw600 suspend-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Delete") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#DF0404"} /> */}
                    <span className="common-status-box delete-status"></span>
                    <span className="fw600 delete-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Stop") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#C00D0D"} /> */}
                    <span className="common-status-box stop-status"></span>
                    <span className="fw600 stop-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "New") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#20C997"} /> */}
                    <span className="common-status-box new-status"></span>
                    <span className="fw600 new-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Completed") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#0461BB"} /> */}
                    <span className="common-status-box completed-status"></span>
                    <span className="fw600 completed-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Closed") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#6F6F6F"} /> */}
                    <span className="common-status-box closed-status"></span>
                    <span className="fw600 colsed-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Running") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#2AB82A"} /> */}
                    <span className="common-status-box running-status"></span>
                    <span className="fw600 running-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Failed") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#D32F2F"} /> */}
                    <span className="common-status-box failed-status"></span>
                    <span className="fw600 failed-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Partial Success") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#FFD700"} /> */}
                    <span className="common-status-box partial-success-status"></span>
                    <span className="fw600 partial-success-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "In Process") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#2B8DC8"} /> */}
                    <span className="common-status-box in-process-status"></span>
                    <span className="fw600 in-process-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Publish") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#008000"} /> */}
                    <span className="common-status-box active-status"></span>
                    <span className="fw600 publish-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Rejected") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#DF0404"} /> */}
                    <span className="common-status-box delete-status"></span>
                    <span className="fw600 rejected-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Pending") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#FFD700"} /> */}
                    <span className="common-status-box partial-success-status"></span>
                    <span className="fw600 pending-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Deprecated") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#FF4500"} /> */}
                    <span className="common-status-box deprecated-status"></span>
                    <span className="fw600 deprecated-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Discontinued") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#C00D0D"} /> */}
                    <span className="common-status-box stop-status"></span>
                    <span className="fw600 discontinued-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Stop") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#C00D0D"} /> */}
                    <span className="common-status-box stop-status"></span>
                    <span className="fw600 stop-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "In Progress") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#2B8DC7"} /> */}
                    <span className="common-status-box in-progress-status"></span>
                    <span className="fw600 inprogress-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "Re-Open") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#EB7900"} /> */}
                    <span className="common-status-box reopen-status"></span>
                    <span className="fw600 reopen-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue.toUpperCase() === "PAID") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#008000"} /> */}
                    <span className="common-status-box active-status"></span>
                    <span className="fw600 publish-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue.toUpperCase() === "UNPAID") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#DF0404"} /> */}
                    <span className="common-status-box delete-status"></span>
                    <span className="fw600 rejected-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue.toUpperCase() === "SUCCEEDED") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#008000"} /> */}
                    <span className="common-status-box active-status"></span>
                    <span className="fw600 publish-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue.toUpperCase() === "CANCELED") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#DF0404"} /> */}
                    <span className="common-status-box delete-status"></span>
                    <span className="fw600 rejected-text">{statusValue}</span>
                </div>
            );
        } else if (statusValue === "PROCESSING") {
            status = (
                <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                    {/* <StatusImgIcon color={"#2B8DC7"} /> */}
                    <span className="common-status-box in-progress-status"></span>
                    <span className="fw600 inprogress-text">{statusValue}</span>
                </div>
            );
        }
    } else {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#2B8DC7"} /> */}
                <span className="common-status-box in-progress-status"></span>
                <span className="fw600 inprogress-text">{statusValue}</span>
            </div>
        );
    }

    return status;
}
function getlogPopupStatus(statusValue) {
    let status = <div></div>;
    if (statusValue === "Active" || statusValue === "Success") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#008000"} /> */}
                <span className="common-status-box active-status"></span>
                <span className="fw600 active-text">{statusValue}</span>
            </div>
        );
    } else if (statusValue === "Completed") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#0461BB"} /> */}
                <span className="common-status-box completed-status"></span>
                <span className="fw600 completed-text">{statusValue}</span>
            </div>
        );
    } else if (statusValue === "Failed") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#D32F2F"} /> */}
                <span className="common-status-box failed-status"></span>
                <span className="fw600 failed-text">{statusValue}</span>
            </div>
        );
    } else if (statusValue === "Partial Success") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#FFD700"} /> */}
                <span className="common-status-box partial-success-status"></span>
                <span className="fw600 partial-success-text">{statusValue}</span>
            </div>
        );
    } else if (statusValue === "Inprogress") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#2B8DC8"} /> */}
                <span className="common-status-box in-progress-status"></span>
                <span className="fw600 in-process-text">{statusValue}</span>
            </div>
        );
    } else if (statusValue === "Pending") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus d-flex align-items-center gap-2">
                {/* <StatusImgIcon color={"#FFA500"} /> */}
                <span className="common-status-box pending-status"></span>
                <span className="fw600 suspend-text">{statusValue}</span>
            </div>
        );
    }
    return status;
}

function getWorkflowStatusColor(status) {
    switch (status) {
        case "Publish":
        case "Save & Publish":
        case "Completed":
        case "Active":
        case "Success":
        case "SUCCEEDED":
            return { backColor: "#0461BB", foreColor: "#dcecf9" };
        case "Suspend":
        case "Pending":
            return { backColor: "#FFA500", foreColor: "#dcecf9" };
        case "Resume":
        case "Inprogress":
        case "PROCESSING":
            return { backColor: "#007BFF", foreColor: "#dcecf9" };
        case "Failed":
        case "CANCELED":
        case "Rejected":
            return { backColor: "#D32F2F", foreColor: "#dcecf9" };
        case "Partial Success":
            return { backColor: "#FFD700", foreColor: "#333333" };
        case "Save":
        case "Save As":
        case "Draft":
        default:
            return { backColor: "#9A9A9A", foreColor: "#dcecf9" };
    }
}

function getlogPopupStatusCapsule(statusValue) {
    const statusColor = getWorkflowStatusColor(statusValue);
    return (
        <span
            className="workflow-status-pill"
            style={{
                backgroundColor: statusColor.backColor,
                color: statusColor.foreColor,
            }}
        >
            {statusValue ?? "--"}
        </span>
    );
}

function getWithoutDotStatus(statusValue) {
    let status = <div></div>;
    //   if (statusValue === "Draft") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Active") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={activestatus} alt="Status" /> */}
    //         <span className="fw600 green-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Resume") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Suspend") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Delete") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Completed") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={activestatus} alt="Status" /> */}
    //         <span className="fw600 green-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Running") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Failed") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   } else if (statusValue === "Partial Success") {
    //     status = (
    //       <div className="status-active tourWorkFlowDashboardStatus">
    //         {/* <img src={inactivestatus} alt="Status" /> */}
    //         <span className="fw600 red-color-text">{"| " + statusValue}</span>
    //       </div>
    //     );
    //   }

    if (statusValue === "Draft") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#A9A9A9"} /> */}
                <span className="fw600 draft-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Active" || statusValue === "Success") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#008000"} /> */}
                <span className="fw600 active-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Resume") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#007BFF"} /> */}
                <span className="fw600 resume-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Suspend") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#FFA500"} /> */}
                <span className="fw600 suspend-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Delete") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#DF0404"} /> */}
                <span className="fw600 delete-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Stop") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#C00D0D"} /> */}
                <span className="fw600 stop-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "New") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#20C997"} /> */}
                <span className="fw600 new-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Completed") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#0461BB"} /> */}
                <span className="fw600 completed-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Running") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#90EE90"} /> */}
                <span className="fw600 running-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Failed") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#DC3545"} /> */}
                <span className="fw600 failed-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Partial Success") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#FFD700"} /> */}
                <span className="fw600 partial-success-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "In Process") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#2B8DC8"} /> */}
                <span className="fw600 in-process-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Publish") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#008000"} /> */}
                <span className="fw600 publish-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Rejected") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#DF0404"} /> */}
                <span className="fw600 rejected-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Pending") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#FFD700"} /> */}
                <span className="fw600 pending-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Deprecated") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#FF4500"} /> */}
                <span className="fw600 deprecated-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Discontinued") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <StatusImgIcon color={"#C00D0D"} /> */}
                <span className="fw600 discontinued-text">{"| " + statusValue}</span>
            </div>
        );
    } else if (statusValue === "Stop") {
        status = (
            <div className="status-active tourWorkFlowDashboardStatus">
                {/* <img src={inactivestatus} alt="Status" /> */}
                <span className="fw600 stop-text">{"| " + statusValue}</span>
            </div>
        );
    }

    return status;
}

function formateAmount(amount) {
    if (!amount && amount !== "0" && amount !== 0) {
        return "";
    }
    let USDollar = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    let formatedAmount = USDollar.format(amount);
    let replacedValue = formatedAmount?.replace(".00", "");

    return replacedValue;
}
function getDateInFormat(date) {
    if (date) {
        return moment(date)?.format("MM/DD/YYYY");
    }
    return "";
}
function UserLogPanalAction(action) {
    let ulp = document.getElementById("userlogpanel");
    if (ulp && action) {
        if (ulp.classList.contains(action)) {
            ulp.classList.remove(action);
        } else {
            ulp.classList.remove("open");
            ulp.classList.remove("close");
            ulp.classList.remove("minimize");
            ulp.classList.remove("maximize");
            ulp.classList.add(action);
            if (action.toLowerCase() === "minimize") {
                ulp.classList.add("open");
            } else if (action.toLowerCase() === "maximize") {
                ulp.classList.add("open");
            }
        }
    }
}

function getUserLogDataInFormat(logdata, UserData) {
    if (logdata && UserData) {
        if (parseInt(logdata.userid) === parseInt(UserData.userid)) {
            let ulpls = document.getElementById("userlogpanel_logs");
            if (ulpls && logdata.log_message) {
                let Message = "";
                if (logdata.log_type === "Machine Upload") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Docker Automation") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Github Repo-Structure") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Github File-Content") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Upload Status") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Generator") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Publish") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Run") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Update Status") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Running Status Update") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Workflow Next Schedule") {
                    Message = logdata.log_message;
                } else if (logdata.log_type === "Running Workflow Machine Log") {
                    Message = "";
                    let logClassName = logdata.log_type.replaceAll(" ", "");

                    let myElement = document.querySelectorAll("." + logClassName);
                    if (myElement) {
                        myElement.forEach((paragraph) => {
                            paragraph.remove();
                        });
                    }
                    logdata.log_message.map((item) => {
                        let Headers = commonservices.makeMachineDisplayName(
                            item?.machinename,
                            0,
                            item?.assemblyname,
                            item?.workflowmachinename
                        );
                        if (Headers) {
                            let p = document.createElement("p");
                            p.classList.add("header");
                            p.classList.add(logClassName);
                            p.innerHTML = Headers;
                            ulpls.append(p);
                            ulpls.scrollTop = ulpls.scrollHeight;
                        }

                        let p = document.createElement("p");
                        p.innerHTML =
                            "<img src='" +
                            doublearrow +
                            "' /> " +
                            item?.logdata
                                .replaceAll(item?.assemblyname, "")
                                .replaceAll("\n", "<br/><img src='" + doublearrow + "' /> ");
                        p.classList.add(logClassName);
                        ulpls.append(p);
                        ulpls.scrollTop = ulpls.scrollHeight;
                    });
                } else {
                    Message = logdata.log_message;
                }

                if (Message) {
                    let p = document.createElement("p");
                    p.innerHTML =
                        "<img src='" +
                        doublearrow +
                        "' /> " +
                        (Message.toLowerCase() === "end"
                            ? "---------------" +
                            logdata.log_type +
                            " Process Completed--------------"
                            : Message);
                    ulpls.append(p);
                    ulpls.scrollTop = ulpls.scrollHeight;
                }
                let ulp = document.getElementById("userlogpanel");
                if (ulp) {
                    if (
                        !ulp.classList.contains("open") &&
                        !ulp.classList.contains("minimize")
                    ) {
                        UserLogPanalAction("open");
                    }
                }
            }
        }
    }
}

function FocusOnValidationField(errClass) {
    const curr_Element = document.querySelector(`.${errClass}`);
    if (curr_Element) {
        curr_Element.scrollIntoView({
            behavior: "smooth", // Smooth scrolling animation
            block: "center", // Align element to the center of the viewport
        });
        return;
    }
}
function setupKeyPressHandler(handleSubmit, targetKey = "Enter") {
    const handleKeyPress = (event) => {
        if (event.key === targetKey) {
            event.preventDefault();
            handleSubmit(event);
        }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
        document.removeEventListener("keydown", handleKeyPress);
    };
}
async function downloadFileFromURL(fileUrl, options = {}, name) {
    const {
        fileName, // Optional file name
        mimeType, // Optional MIME type
        returnType = "file", // "file", "blob", or "arrayBuffer"
    } = options;

    try {
        const response = await fetch(fileUrl);

        if (!response.ok) {
            throw new Error(
                `Failed to download the file. HTTP status: ${response.status}`
            );
        }

        const blob = await response.blob();

        // Extract file name from URL if not provided
        // let extractedFileName = fileName || fileUrl.split('/').pop().split('?')[0] || "downloadedFile";
        let extractedFileName = name;

        if (returnType === "blob") {
            // Convert Blob to File with extracted name
            const file = new File([blob], extractedFileName, {
                type: mimeType || blob.type,
            });
            return file; // Return as a File instead of a Blob
        } else if (returnType === "arrayBuffer") {
            return await blob.arrayBuffer();
        }

        const file = new File([blob], extractedFileName, {
            type: mimeType || blob.type,
        });

        return file;
    } catch (error) {
        return null;
    }
}
async function readJsonFileFromUrl(url) {
    let fileData = "";
    try {
        const response = await axios.get(url);
        fileData = response?.data;
    } catch (error) { }

    return fileData;
}
function convertDateAndTimeInLocalTimeZone(date, formate = "YYYY-MM-DD") {
    let localDate = "";
    if (date) {
        const utcDate = `${date}`;
        const compatibleDate = utcDate.split(".")[0] + "Z";
        localDate = moment(compatibleDate).local().format(`${formate}`);
    }
    return localDate;
}

function makeMachineDisplayName(
    machinename,
    noofsamemachine,
    assemblyname,
    workflowmachinename
) {
    let name = "";
    if (workflowmachinename && assemblyname && machinename) {
        name =
            machinename +
            (workflowmachinename.replace(assemblyname, "").replace("Loop-", "")
                ? "-" +
                workflowmachinename.replace(assemblyname, "").replace("Loop-", "")
                : "");
    } else {
        name = machinename + (noofsamemachine !== 0 ? "-" + noofsamemachine : "");
    }

    if (name === null || name === "" || name.toLowerCase() === "null") {
        name = machinename;
    }

    if (name === null || name === "" || name.toLowerCase() === "null") {
        name = assemblyname;
    }

    if (name === null || name === "" || name.toLowerCase() === "null") {
        name = "";
    }
    return name;
}
function validateJsonString(jsonString) {
    try {
        JSON.parse(jsonString);
        return { valid: true, error: null };
    } catch (e) {
        if (e.message.includes("Unexpected token")) {
            return {
                valid: false,
                error: "Syntax error: possibly missing a comma between objects.",
            };
        }
        return { valid: false, error: `Invalid JSON: ${e.message}` };
    }
}

function CreateColor(str) {
    let BGRGB = "000000";
    let FRGB = "FFFFFF";

    BGRGB = getColorByName(str);
    FRGB = getContrastingTextColor(BGRGB);
    return { BGColor: BGRGB, FontColor: FRGB };
}

function getContrastingTextColor(backgroundColor) {
    // Convert hex color to RGB
    const hex = backgroundColor.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black for light backgrounds and white for dark backgrounds
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
}

function getColorByName(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).slice(-2);
    }
    return color;
}

//function CreateColor(str) {
//  let BGRGB = "000000";
//  let FRGB = "FFFFFF";
//  if (str !== "") {
//    str = str + "000000";
//    let hash = hashCode(str);
//    BGRGB = intToRGB(hash);
//    FRGB = invertColor(BGRGB);
//  }
//  return { BGColor: BGRGB, FontColor: FRGB };
//}

//function hashCode(str) {
//  var hash = 0;
//  for (var i = 0; i < str.length; i++) {
//    hash = str.charCodeAt(i) + ((hash << 5) - hash);
//  }
//  return hash;
//}

//function intToRGB(i) {
//  var c = (i & 0x00ffffff).toString(16).toUpperCase();
//  return "#" + "000000".substring(0, 6 - c.length) + c;
//}

//function invertColor(hex) {
//  if (hex.indexOf("#") === 0) {
//    hex = hex.slice(1);
//  }
//  if (hex.length === 3) {
//    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
//  }
//  if (hex.length !== 6) {
//    throw new Error("Invalid HEX color.");
//  }

//  var r = (255).toString(16),
//    g = (255).toString(16),
//    b = (255).toString(16);
//  return "#" + padZero(r) + padZero(g) + padZero(b);
//}
//function padZero(str, len) {
//  len = len || 2;
//  var zeros = new Array(len).join("0");
//  return (zeros + str).slice(-len);
//}
function fnTotalMonths() {
    let months = [];
    for (let index = 1; index <= 12; index++) {
        months.push(index);
    }
    return months;
}
function fnLastYearList(totalyear) {
    const lastYears = [];
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < totalyear; i++) {
        lastYears.push(currentYear - i);
    }
    // setLastyearList(lastYears);
    return lastYears;
}
function fnAmountDigitCount(amount, count) {
    return amount?.toFixed(count);
}

function CalculateUseInPersentage(oldValue, newValue) {
    if (oldValue && newValue) {
        return (((newValue - oldValue) / oldValue) * 100).toFixed(2);
    } else {
        return "--";
    }
}
function getNewTimeZone() {
    const allTimezones = moment.tz.names();
    return allTimezones.map((timezone) => ({
        displayName: `(${moment.tz(timezone).zoneName()}) ${timezone}`,
        value: timezone,
        shortValue: moment.tz(timezone).zoneName(),
    }));
}
function FillMultiSelectValue(main_value, arr_list, title) {
    if (arr_list) {
        let temp = arr_list.find((f) => f.value === main_value);
        if (temp) {
            return temp;
        }
    }
    return null;
}
function bodyEncryption(request, isStringify) {
    var request = isStringify ? JSON.stringify(request) : request;
    let encrypted = CryptoJS.AES.encrypt(request, key, { iv: iv });
    let base64 = encrypted
        .toString()
        .replace(/\//g, "_") // Replace / with _
        .replace(/\+/g, "-") // Replace + with -
        .replace(/=+$/, ""); // Remove trailing =

    return base64;
}

function bodyDecryption(request) {
    let base64 = request?.replace(/_/g, "/")?.replace(/-/g, "+");

    let decrypted = CryptoJS.AES.decrypt(base64, key, { iv: iv });

    return decrypted?.toString(CryptoJS.enc.Utf8);
}
function fnORGIcon(org_icon) {
    if (org_icon === "Developer") {
        return <img src={workflowIcon} alt={org_icon} />;
    } else if (org_icon === "Workflow") {
        return <img src={developerorg} alt={org_icon} />;
    } else {
        return <img src={community} alt={org_icon} />;
    }
}

function getKeyPaths(obj, prefix = "", result = new Set()) {
    for (let key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const fullKey = prefix ? `${prefix}.${key}` : key;
        const value = obj[key];

        if (result.has(fullKey)) continue;

        if (Array.isArray(value)) {
            result.add(fullKey);
            result.add({
                key: fullKey,
                type: "Array",
                label: fullKey,
                value: value,
            });
            if (typeof value[0] !== "number" && typeof value[0] !== "string") {
                getKeyPaths(value[0], fullKey, result);
            }
        } else if (typeof value === "object" && value !== null) {
            result.add(fullKey);
            result.add({
                key: fullKey,
                type: "Object",
                label: fullKey,
                value: value,
            });
            getKeyPaths(value, fullKey, result);
        } else {
            result.add(fullKey);
            result.add({
                key: fullKey,
                type: typeof value,
                label: fullKey,
                value: value,
            });
        }
    }

    // Convert Set to Array and return the result
    return Array.from(result).filter((item) => typeof item !== "string");
}

function GenerateGUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

function GetTotalMinutesBaseOnDateTime(_date) {
    const date = new Date(_date);

    const hours = date.getHours();
    const minutes = date.getMinutes();

    return (hours * 60 + minutes) > 0 ? (hours * 60 + minutes) : 1;
}

function getFileExtension(fileName) {
    if (!fileName || !fileName.includes('.')) return "";
    return "." + fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
}



export const getCardBrandImage = (brandName) => {
    const normalizedBrand = brandName
        ?.replace(/[_\s]/g, "") // Replace spaces and underscores
        .toUpperCase();

    switch (normalizedBrand) {
        case "AMERICANEXPRESS":
            return <img src={AmericanExpress} alt="AmericanExpress" />;
        case "VISA":
            return <img src={Visa} alt="Visa" />;
        case "MASTERCARD":
            return <img src={MasterCard} alt="MasterCard" />;
        case "DISCOVER":
            return <img src={Discover} alt="Discover" />;
        case "RUPAY":
            return <img src={RuPay} alt="RuPay" />;
        case "PAYPAL":
            return <img src={Paypal} alt="Paypal" />;
        case "DEBITCARD":
            return <img src={DebitCard} alt="DebitCard" />;
        case "CREDITCARD":
            return <img src={CreditCard} alt="CreditCard" />;
        default:
            return <img src={CreditCard} alt="CreditCard" />; // fallback
    }
};

export const getNormalisedBrandName = (str = "") => {
    return str
        .replace(/_/g, " ") // Replace underscores with spaces
        .split(" ") // Split into words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
        .join(" "); // Join back to string
};

export async function loadFileContent(url) {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            throw new Error("Failed to fetch file.");
        }

        // Detect file type from URL
        const fileExt = url.split(".").pop().split("?")[0].toLowerCase();

        let output = "";

        if (fileExt === "json") {
            const data = await res.json();
            output = JSON.stringify(data, null, 2);  // formatted JSON
        } else if (fileExt === "txt") {
            output = await res.text();
        } else {
            // fallback: try as text
            output = await res.text();
        }

        return output;  // FINAL OUTPUT ONLY
    } catch (err) {
        console.error("loadFileContent error:", err);
        return "";
    }
}



function getWorkflowTimeLineStatus(statusValue) {
    let status = <span class="status st-scheduled"><span class="dot"></span>-</span>;
    if (statusValue) {
        if (statusValue.toUpperCase() === "END") {
            status = (
                <span class="status st-ok"><span class="dot"></span>Completed</span>
            );
        } else if (statusValue.toUpperCase() === "PARTIAL SUCCESS" || statusValue.toUpperCase() === "FAILED") {
            status = (
                <span class="status st-bad"><span class="dot"></span>Failed</span>
            );
        } else if (statusValue.toUpperCase() === "START") {
            status = (
                <span class="status st-running"><span class="dot"></span>Running</span>
            );
        }
        else if (statusValue.toUpperCase() === "SCHEDULE") {
            status = (
                <span class="status st-scheduled"><span class="dot"></span>Scheduled</span>
            );
        }



    }

    return status;
}

function ConvetSecondInTimeFormate(Seconds) {
    if (Seconds) {
        if (Seconds <= 60) {
            return <>00:00:{String(Seconds).padStart(2, "0")}</>;
        } else if (Seconds < 3600) {
            const minutes = Math.floor(Seconds / 60);
            const seconds = Seconds % 60;
            return (
                <>
                    00:{String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
                </>
            );
        } else {
            const hours = Math.floor(Seconds / 3600);
            const minutes = Math.floor((Seconds % 3600) / 60);
            const seconds = Seconds % 60;

            return (
                <>
                    {String(hours).padStart(2, "0")}:{String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
                </>
            );
        }
    } else {
        return <>{"00:00:00"}</>;
    }
}

function GetSecondCounts(startTime, endTime) {
    // If endTime is missing, use current time
    if (!endTime) {
        endTime = new Date();
    }

    // Parse a timestamp (string or Date object)
    const parseTimestamp = (timestamp) => {
        if (!timestamp) return null;

        // If it's a Date object
        if (timestamp instanceof Date) {
            return {
                hours: timestamp.getHours(),
                minutes: timestamp.getMinutes(),
                seconds: timestamp.getSeconds(),
            };
        }

        // If it's a string e.g. "2025-11-17T12:34:56"
        if (typeof timestamp === "string" && timestamp.includes("T")) {
            const [datePart, timePart] = timestamp.split("T");
            if (!timePart) return null;

            const [hh = "0", mm = "0", ss = "0"] = timePart.split(":");

            return {
                hours: parseInt(hh, 10) || 0,
                minutes: parseInt(mm, 10) || 0,
                seconds: parseInt(ss, 10) || 0,
            };
        }

        return null;
    };

    const start = parseTimestamp(startTime);
    const end = parseTimestamp(endTime);

    if (!start || !end) {
        return 0;
    }

    const startTotalSeconds =
        start.hours * 3600 + start.minutes * 60 + start.seconds;
    const endTotalSeconds =
        end.hours * 3600 + end.minutes * 60 + end.seconds;

    return endTotalSeconds - startTotalSeconds;
}


function extractArrayKeyPaths(data, rootPath = "", pathSet = new Set()) {
    if (!data || typeof data !== "object") {
        return pathSet;
    }

    if (Array.isArray(data)) {
        if (rootPath) {
            pathSet.add(rootPath);
        }

        data.forEach((item) => {
            if (item && typeof item === "object") {
                extractArrayKeyPaths(item, rootPath, pathSet);
            }
        });

        return pathSet;
    }

    Object.keys(data).forEach((key) => {
        const value = data[key];
        const currentPath = rootPath ? rootPath + "." + key : key;

        if (Array.isArray(value)) {
            pathSet.add(currentPath);
            value.forEach((item) => {
                if (item && typeof item === "object") {
                    extractArrayKeyPaths(item, currentPath, pathSet);
                }
            });
            return;
        }

        if (value && typeof value === "object") {
            extractArrayKeyPaths(value, currentPath, pathSet);
        }
    });

    return pathSet;
}


function getJsonPathsWithType(json, rootName = "data") {
    const result = [];
    const visited = new Set();

    function getStringType(value) {

        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return "date";
        }

        // Time: HH:mm or HH:mm:ss
        if (/^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/.test(value)) {
            return "time";
        }

        if (
            /^\d{4}-\d{2}-\d{2}[ T]([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/.test(value)
        ) {
            return "datetime";
        }

        return "string";
    }

    function getType(value) {
        if (Array.isArray(value)) {
            if (value.length === 0) return "array";

            const first = value[0];

            if (Array.isArray(first)) return "array";

            if (first !== null && typeof first === "object") {
                return "array<object>";
            }

            if (typeof first === "number") {
                return Number.isInteger(first)
                    ? "array<number>"
                    : "array<decimal>";
            }

            if (typeof first === "string") {
                return `array<${getStringType(first)}>`;
            }

            return `array<${typeof first}>`;
        }

        if (value === null) return "null";

        if (typeof value === "number") {
            return Number.isInteger(value) ? "number" : "decimal";
        }

        if (typeof value === "string") {
            return getStringType(value);
        }

        return typeof value;
    }

    function traverse(value, path) {
        if (!visited.has(path)) {
            visited.add(path);
            result.push({
                key: path,
                type: getType(value)
            });
        }

        if (Array.isArray(value)) {
            if (
                value.length > 0 &&
                value[0] !== null &&
                typeof value[0] === "object" &&
                !Array.isArray(value[0])
            ) {
                traverse(value[0], path);
            }
        } else if (value !== null && typeof value === "object") {
            Object.entries(value).forEach(([key, val]) => {
                traverse(val, `${path}.${key}`);
            });
        }
    }

    traverse(json, rootName);

    return result;
}


function getJsonPathsWithType_WithouArrayKayWherePosition(json, rootName = "data") {
    const result = [];
    const visited = new Set();

    function getStringType(value) {

        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return "date";
        }

        // Time: HH:mm or HH:mm:ss
        if (/^([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/.test(value)) {
            return "time";
        }

        if (
            /^\d{4}-\d{2}-\d{2}[ T]([01]\d|2[0-3]):([0-5]\d)(:[0-5]\d)?$/.test(value)
        ) {
            return "datetime";
        }

        return "string";
    }

    function getType(value) {
        if (Array.isArray(value)) {
            if (value.length === 0) return "array";

            const first = value[0];

            if (Array.isArray(first)) return "array";

            if (first !== null && typeof first === "object") {
                return "array<object>";
            }

            if (typeof first === "number") {
                return Number.isInteger(first)
                    ? "array<number>"
                    : "array<decimal>";
            }

            if (typeof first === "string") {
                return `array<${getStringType(first)}>`;
            }

            return `array<${typeof first}>`;
        }

        if (value === null) return "null";

        if (typeof value === "number") {
            return Number.isInteger(value) ? "number" : "decimal";
        }

        if (typeof value === "string") {
            return getStringType(value);
        }

        return typeof value;
    }

    function traverse(value, path) {
        if (!visited.has(path)) {
            visited.add(path);
            result.push({
                key: path,
                type: getType(value)
            });
        }

        // Stop here if it's an array
        if (Array.isArray(value)) {
            return;
        }

        if (value !== null && typeof value === "object") {
            Object.entries(value).forEach(([key, val]) => {
                traverse(val, `${path}.${key}`);
            });
        }
    }

    traverse(json, rootName);

    return result;
}


function getQDDataTypeBaseOnType(type) {
    let _type = "Text Box";
    if (type) {
        if (type.toUpperCase() === "ARRAY<OBJECT>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "NUMBER") {
            _type = "Number";
        }
        else if (type.toUpperCase() === "STRING") {
            _type = "Text Box";
        }
        else if (type.toUpperCase() === "OBJECT") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "ARRAY<STRING>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "ARRAY<NUMBER>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "ARRAY<DECIMAL>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "DECIMAL") {
            _type = "Decimal";
        }
        else if (type.toUpperCase() === "BOOLEAN") {
            _type = "Boolean";
        }
        else if (type.toUpperCase() === "ARRAY<BOOLEAN>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "DATE") {
            _type = "Date Picker";
        }
        else if (type.toUpperCase() === "ARRAY<DATE>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "TIME") {
            _type = "Time Picker";
        }
        else if (type.toUpperCase() === "ARRAY<TIME>") {
            _type = "Json";
        }
        else if (type.toUpperCase() === "DATETIME") {
            _type = "Date Time Picker";
        }
        else if (type.toUpperCase() === "ARRAY<DATETIME>") {
            _type = "Json";
        }
    }
    return _type;

}

  function TopOlogicalSort(nodes, edges) {
        const GetIDOfLoopStart = nodes.filter(
            (item) => item?.shortName === "loopstart-0-0-0"
        )[0]?.id;
        const GetIDOfLoopEnd = nodes.filter(
            (item) => item?.shortName === "loopend-0-0-0"
        )[0]?.id;

        const inDegree = new Map();
        const adjList = new Map();
        nodes.forEach((node) => {
            inDegree.set(node.id, 0);
            adjList.set(node.id, []);
        });

        edges.forEach((edge) => {
            adjList.get(edge.source).push(edge.target);
            inDegree.set(edge.target, inDegree.get(edge.target) + 1);
        });

        const queue = [];

        const sortedNodes = [];

        inDegree.forEach((degree, nodeId) => {
            if (degree === 0) {
                queue.push(nodeId);
            }
        });
        while (queue.length > 0) {
            const currentNode = queue.shift();
            sortedNodes.push(currentNode);

            adjList.get(currentNode).forEach((neighbor) => {
                inDegree.set(neighbor, inDegree.get(neighbor) - 1);
                if (inDegree.get(neighbor) === 0) {
                    queue.push(neighbor);
                }
            });
        }
        if (sortedNodes.length !== nodes.length) {
            return [];
        }

        function getDependencies(key, map, loopEnd, visited = new Set()) {
            if (visited.has(key) || key === loopEnd) {
                return []; // Stop recursion if key is visited or it's the loop end
            }

            visited.add(key);
            const dependencies = map.get(key) || [];

            return [
                key,
                ...dependencies.flatMap((depKey) =>
                    map.has(depKey) && depKey !== loopEnd
                        ? getDependencies(depKey, map, loopEnd, visited)
                        : []
                ),
            ];
        }
        let GetLoopMembers = getDependencies(
            GetIDOfLoopStart,
            adjList,
            GetIDOfLoopEnd
        );

        GetLoopMembers = GetLoopMembers.filter((item) => item !== GetIDOfLoopEnd);

        GetLoopMembers.push(GetIDOfLoopEnd);

        const ListData = sortedNodes?.filter((item) => {
            if (!GetLoopMembers.includes(item)) {
                return item;
            }
        });

        const finalNode = [...ListData, ...GetLoopMembers].filter(Boolean);

        let sortedNodesData = finalNode.map((nodeId) =>
            nodes.find((node) => node.id === nodeId)
        );
        sortedNodesData = sortedNodesData.map((node) =>
            GetLoopMembers.includes(node.id)
                ? {
                    ...node,
                    shortName:
                        node.shortName === "loopstart-0-0-0" ||
                            node.shortName === "loopend-0-0-0"
                            ? node.shortName
                            : `${node.shortName}-Loop-{{inputs.parameters.count}}`,
                }
                : node
        );

        return sortedNodesData;
    }
